import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material'
import { useContext, useMemo } from 'react'

import { LaborApplication } from '../../../sdk'
import { SingleMaintenanceSchedule } from '../../../sdk/models/SingleMaintenanceSchedule'
import { MaintenanceScheduleContext } from './MaintenanceScheduleProvider'
export const MaintenanceScheduleAccordion = ({
  title,
  maintenanceSchedules
}: {
  title: string
  maintenanceSchedules: SingleMaintenanceSchedule[]
}) => {
  const { selected, setSelected } = useContext(MaintenanceScheduleContext)
  const selectedIds = useMemo(() => selected.map((s) => s.id!), [selected])
  const handleToggle = (application: LaborApplication) => () => {
    const currentIndex = selectedIds.indexOf(application.id!)
    const newChecked = [...selected]
    if (currentIndex === -1) {
      newChecked.push(application)
    } else {
      newChecked.splice(currentIndex, 1)
    }
    setSelected(newChecked)
  }
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
        sx={{
          backgroundColor: 'primary.main',
          '& .MuiAccordionSummary-content.Mui-expanded': {
            my: 0
          }
        }}>
        <Typography sx={{ color: 'white', fontWeight: 'bold' }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <List dense disablePadding>
          {maintenanceSchedules.map((schedule, i) => (
            <ListItemButton
              role={undefined}
              key={i}
              onClick={handleToggle(schedule.laborApplication!)}
              dense>
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={selectedIds?.includes(
                    schedule.laborApplication!.id!
                  )}
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  schedule.laborApplication?.taxonomy?.literalName +
                  (schedule.laborApplication?.positionName
                    ? ` (${schedule.laborApplication.positionName})`
                    : '')
                }
                secondary={schedule.timingInfoList!.notes?.join(', ') || ''}
              />
            </ListItemButton>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  )
}
